var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.scoreData)?_c('person-score-graph',{attrs:{"score-data":_vm.scoreData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }